import { render } from "./EmployeePanelHeader.vue?vue&type=template&id=7dab7a48&scoped=true"
import script from "./EmployeePanelHeader.vue?vue&type=script&lang=js"
export * from "./EmployeePanelHeader.vue?vue&type=script&lang=js"

import "./EmployeePanelHeader.vue?vue&type=style&index=0&id=7dab7a48&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab7a48"]])

export default __exports__